import { VERTICALS } from '../data/verticals';
import VerticalPage from './VerticalPage';

const ReligiousTrusts = () => <VerticalPage config={VERTICALS['religious-trusts']} />;

export default ReligiousTrusts;
